import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { menuIsOpenAction } from 'reducer/common/menuDropback';
import Backdrop from 'tradevan-ui/Backdrop';

interface MenuDropbackProps {
  _show: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
}
const MenuDropback = (props: MenuDropbackProps) => {
  const {
    _show: [show, setShow],
  } = props;
  const dispatch = useDispatch();
  const { setMenuIsOpen } = menuIsOpenAction;
  const [windowSize, setWindowSize] = useState(0);

  /** 設定選單的型態 condensed = IconMenu 、default = 正常選單 */
  const setBodyAttr = () => {
    if (windowSize >= 768 && windowSize <= 1028) {
      document.body.setAttribute('data-sidebar-size', 'condensed');
    } else {
      document.body.setAttribute('data-sidebar-size', 'default');
    }
  };

  const handleColseBackdrop = () => {
    setShow(false);
    dispatch(setMenuIsOpen(false));
  };

  useEffect(() => {
    setBodyAttr();
    // 是否開啟Backdrop
    setShow(
      windowSize <= 768 && document.body.classList[0] === 'sidebar-enable',
    );
  }, [windowSize]);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <Backdrop
      onClick={() => {
        handleColseBackdrop();
      }}
      sx={{ zIndex: 3 }}
      show={show}
    />
  );
};

export default MenuDropback;
